module.exports = __webpack_public_path__ + "assets/img/Type E (4).8cec96c6.jpg";